<template>
  <svg
    :class="customStyle"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.3011 1.22123C8.25088 1.15585 8.18761 1.10097 8.11508 1.05987C8.04254 1.01877 7.96222 0.992286 7.87892 0.98201C7.79562 0.971733 7.71104 0.97787 7.63023 1.00005C7.54942 1.02224 7.47404 1.06001 7.4086 1.11113C5.81155 2.35671 4.75812 4.14268 4.45943 6.11105C3.91208 5.72545 3.43231 5.25663 3.0386 4.72264C2.98513 4.65002 2.91583 4.58975 2.83564 4.54613C2.75544 4.50251 2.66634 4.47661 2.57466 4.47027C2.48299 4.46393 2.391 4.47731 2.30526 4.50945C2.21952 4.5416 2.14213 4.59172 2.0786 4.65625C0.978039 5.77472 0.272561 7.20453 0.0643628 8.73856C-0.143835 10.2726 0.156058 11.8312 0.920601 13.1886C1.68514 14.5459 2.87464 15.6316 4.31677 16.2883C5.75891 16.9451 7.37881 17.1387 8.94181 16.8413C10.5048 16.5438 11.9298 15.7707 13.0102 14.6339C14.0907 13.4971 14.7706 12.0556 14.9515 10.5183C15.1323 8.98103 14.8047 7.42771 14.0161 6.08339C13.2275 4.73906 12.0189 3.67354 10.5653 3.04115C9.67167 2.61901 8.89526 1.99494 8.3011 1.22123ZM10.6236 10.907C10.6233 11.3461 10.5249 11.78 10.3353 12.1786C10.1456 12.5772 9.86922 12.9311 9.52512 13.2159C9.18103 13.5007 8.77744 13.7095 8.3422 13.8281C7.90695 13.9466 7.45042 13.972 7.00409 13.9025C6.55776 13.833 6.13226 13.6703 5.75695 13.4256C5.38163 13.1808 5.06544 12.8599 4.83019 12.4849C4.59493 12.1099 4.44621 11.6898 4.39429 11.2536C4.34236 10.8174 4.38847 10.3754 4.52944 9.95815C5.05277 10.3346 5.65443 10.6139 6.30693 10.7677C6.48384 9.65938 7.05074 8.64488 7.9111 7.89697C8.66194 7.99411 9.3509 8.35288 9.84985 8.90655C10.3488 9.46022 10.6238 10.1711 10.6236 10.907Z"
      fill="#218579"
    />
  </svg>
</template>

<script>
export default {
  name: 'FireIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
